// src/Service/fetchMetadata.js
import { api } from './fetchDeployments';

/**
 * Fetches metadata for a specific deployment
 * @param {string} site - The deployment site identifier
 * @returns {Promise<{latitude: number|null, longitude: number|null, verticalPosition: number[]}>}
 */
export async function fetchMetadata(site) {
  try {
    console.log('Fetching metadata for site:', site);

    const response = await api.get(
      `/metadata/${encodeURIComponent(site)}`
    );

    console.log('Metadata raw response:', response.data);

    // Handle empty arrays case
    if (response.data && 
        Array.isArray(response.data.latitude) && 
        Array.isArray(response.data.longitude)) {
      
      // Check if arrays have values
      if (response.data.latitude.length === 0 || response.data.longitude.length === 0) {
        console.log('Metadata arrays are empty');
        return {
          latitude: null,
          longitude: null,
          verticalPosition: []
        };
      }

      // Arrays have values, extract them
      const metadata = {
        latitude: response.data.latitude[0],
        longitude: response.data.longitude[0],
        verticalPosition: response.data.verticalPosition || []
      };

      console.log('Extracted metadata:', metadata);
      return metadata;
    }

    console.warn('Invalid metadata format received:', response.data);
    return {
      latitude: null,
      longitude: null,
      verticalPosition: []
    };

  } catch (error) {
    console.error("Error fetching metadata:", error);
    return {
      latitude: null,
      longitude: null,
      verticalPosition: []
    };
  }
}

/**
 * Fetches site coordinates for a specific deployment
 * @param {string} site - The deployment site identifier
 * @returns {Promise<{latitude: number|null, longitude: number|null}>}
 */
export async function fetchSiteCoordinates(site) {
  try {
    const metadata = await fetchMetadata(site);
    
    // Check if we actually got coordinates
    if (metadata.latitude !== null && metadata.longitude !== null) {
      return {
        latitude: metadata.latitude,
        longitude: metadata.longitude
      };
    }
    
    console.warn('No coordinates available for site:', site);
    return {
      latitude: null,
      longitude: null
    };
  } catch (error) {
    console.error("Error fetching site coordinates:", error);
    return {
      latitude: null,
      longitude: null
    };
  }
}